import types from './types';

const cleanCache = () => ({
  type: types.ENTITY_CLEAN_CACHE,
});

export default {
  cleanCache,
};
